import {XCloseIcon} from '@components/ui/icon'
import {ReactNode} from 'react'
import RHT, {Toast} from 'react-hot-toast'
import {Button} from '@components/ui/button'

const renderToast = (content: ReactNode, id: string, variant: 'ghost' | 'ghostDanger' | 'ghostSuccess' = 'ghost') => (
    <div className="grid grid-cols-[1fr_auto] items-center gap-8">
        <div>{content}</div>
        <Button variant={variant} shape="square" onClick={() => RHT.dismiss(id)}>
            <XCloseIcon />
        </Button>
    </div>
)

type Options = Partial<
    Pick<Toast, 'className' | 'id' | 'style' | 'icon' | 'duration' | 'ariaProps' | 'position' | 'iconTheme'>
>

export const toast = {
    success: (content: ReactNode, options?: Options) =>
        RHT.success(t => renderToast(content, t.id, 'ghostSuccess'), options),
    error: (content: ReactNode, options?: Options) =>
        RHT.error(t => renderToast(content, t.id, 'ghostDanger'), options),
    info: (content: ReactNode, options?: Options) => RHT(t => renderToast(content, t.id), options)
}
